import { render, staticRenderFns } from "./VerkaQuickActionLink.vue?vue&type=template&id=ccd15dfe&scoped=true&"
import script from "./VerkaQuickActionLink.vue?vue&type=script&lang=ts&"
export * from "./VerkaQuickActionLink.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaQuickActionLink.vue?vue&type=style&index=0&id=ccd15dfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd15dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VSpacer})
